export const URL_TRIVIA = process.env.NEXT_PUBLIC_TRIVIA_ORIGIN;
